import styled from 'styled-components';
import * as colors from '~/config/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: row;  
 

  @media (min-width: 890px) { 
    width: 90rem;
    height: 70rem;   
  }
  .Container__grupos {         
  }
  .Container__nf_busca {    
    display: grid;
    grid-template-columns:  1fr  ;
    @media (min-width: 890px) { //980
      width: 90rem;  
      height: 9rem;    
    }    
    border: none;    
    //padding: 5px 5px;   
    input{
        height: 1rem;  
        color : black;        
        letter-spacing: 1px;        
        text-align: left;     
    }
    .MuiFormControl-root{
      margin-top:5px;
    }
  }

  .Container__nf_dados { 
    display: grid;
    gap: 10px; 
    margin: 10px;  
    @media (min-width: 890px) { //980
      display: grid;
      grid-template-columns: 1fr 1fr ;
      gap: 5px;         
      width: 90rem;  
      height: 25rem;        
      border: none;
      padding: 5px 5px; 
      margin: 5px ;      
    }
    input {
        height: 1rem;  
        font-size: 1.2rem;       
        color : black;        
        letter-spacing: 1px;        
        text-align: right;
        background: ${colors.CAMPO_INFORMACAO};              
    }
  }

  .Container__nf_dados_grade {
    display: inline;
    @media (min-width: 890px) { //980
      //width: 90rem;  
     height: 25rem;  
    }
    padding: 5px 5px; 
    margin: 5px ;
  }

  .Container__nf_dados_resumo {
    /* display: grid;
    grid-template-columns: 1fr 1fr  ;
    @media (min-width: 890px) { 
      width: 90rem; 
      height: 8rem;    
    }  
    border: none;   
    padding: 0px 5px; 
    margin: 2px ; */

    display: grid;
    //gap: 10px; 
    //margin: 10px;  
    @media (min-width: 890px) { //980
      display: grid;
      grid-template-columns: 1fr 1fr ;
      gap: 5px;         
      width: 90rem;  
      height: 8rem;        
      border: none;
      //padding: 5px 5px; 
      //margin: 5px ;      
    }
    input {
        height: 1rem;  
        font-size: 1.2rem;       
        color : black;        
        letter-spacing: 1px;        
        text-align: right;
        background: ${colors.CAMPO_INFORMACAO};              
    }
  }

  .Container__info {        
    input {
        height: 1rem;  
        background: ${colors.CAMPO_INFORMACAO};        
    }
  }

  .Container__liberacao {        
    input {
        height: 1rem;  
        font-size: 2rem;       
        color : black;
        font-weight: 900;
        letter-spacing: 1px;
        font-family:  'verdana, sans-serif';
        text-align: center;
        background: ${colors.CAMPO_INFORMACAO};       
    }
  }
`;

